// extracted by mini-css-extract-plugin
export var articleList = "newest-articles-module--article-list--061ac";